// extracted by mini-css-extract-plugin
module.exports = {"bkw-D":"D_bkw-D__pY5Ot"};